/**
 * @generated SignedSource<<b4e5ad9dc18e6ea287ee7029c219832f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUCategoryCreateMutation$variables = {
  color: string;
  title: string;
};
export type PLUCategoryCreateMutation$data = {
  readonly createPLUCategory: {
    readonly pluCategories: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
  } | null;
};
export type PLUCategoryCreateMutation = {
  response: PLUCategoryCreateMutation$data;
  variables: PLUCategoryCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "color"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "color",
        "variableName": "color"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "PLUCategoryCreatePayload",
    "kind": "LinkedField",
    "name": "createPLUCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "pluCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategoryCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUCategoryCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "48548c8ebb4ae29b7053875ac30b28bc",
    "id": null,
    "metadata": {},
    "name": "PLUCategoryCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PLUCategoryCreateMutation(\n  $color: String!\n  $title: String!\n) {\n  createPLUCategory(color: $color, title: $title) {\n    pluCategories {\n      id\n      title\n      color\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e71c6ce48f4134eddd70822da08105c0";

export default node;
